import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import axios from "axios";
import { Lock, Mail } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await axios.post(`${API}/auth/login`, formData);
      localStorage.setItem("adminToken", response.data.access_token);
      toast.success("Login successful!");
      navigate("/admin/dashboard");
    } catch (error) {
      toast.error("Invalid email or password");
      console.error("Login error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F5F7FA] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1
            className="text-4xl font-bold text-[#1A1A1A] mb-2"
            style={{ fontFamily: "'Playfair Display', serif" }}
            data-testid="admin-login-heading"
          >
            RERA<span className="text-[#C9A14A]">Hub</span>
          </h1>
          <p className="text-slate-600">Admin Portal</p>
        </div>

        <div className="bg-white p-8 md:p-10 border border-slate-100 shadow-lg rounded-none" data-testid="admin-login-form-container">
          <h2
            className="text-2xl font-semibold text-[#0A1321] mb-6"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Sign In
          </h2>

          <form onSubmit={handleSubmit} data-testid="admin-login-form">
            <div className="mb-6">
              <label htmlFor="email" className="block text-sm font-medium text-[#0A1321] mb-2">
                Email Address
              </label>
              <div className="relative">
                <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full bg-white border border-slate-200 focus:border-[#C9A14A] focus:ring-1 focus:ring-[#C9A14A] rounded-none p-4 pl-12 shadow-sm outline-none transition-colors duration-300"
                  placeholder="admin@company.com"
                  data-testid="admin-login-email-input"
                />
              </div>
            </div>

            <div className="mb-6">
              <label htmlFor="password" className="block text-sm font-medium text-[#0A1321] mb-2">
                Password
              </label>
              <div className="relative">
                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  className="w-full bg-white border border-slate-200 focus:border-[#C9A14A] focus:ring-1 focus:ring-[#C9A14A] rounded-none p-4 pl-12 shadow-sm outline-none transition-colors duration-300"
                  placeholder="Enter your password"
                  data-testid="admin-login-password-input"
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="btn-primary w-full px-8 py-4 rounded-none font-medium disabled:opacity-50 disabled:cursor-not-allowed"
              data-testid="admin-login-submit-button"
            >
              {isLoading ? "Signing in..." : "Sign In"}
            </button>
          </form>

          <div className="mt-6 p-4 bg-slate-50 border border-slate-200 rounded-none">
            <p className="text-sm text-slate-600 mb-1">
              <strong>Default Credentials:</strong>
            </p>
            <p className="text-sm text-slate-600">Email: admin@company.com</p>
            <p className="text-sm text-slate-600">Password: Admin@123</p>
          </div>
        </div>

        <div className="text-center mt-6">
          <button
            onClick={() => navigate("/")}
            className="text-slate-600 hover:text-[#C9A14A] transition-colors duration-300"
            data-testid="admin-login-back-to-home-link"
          >
            ← Back to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;